var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31591 13.5C3.11591 13.5 2.09659 13.0816 1.25795 12.2449C0.419318 11.4082 0 10.3912 0 9.19388C0 8.13265 0.340909 7.20068 1.02273 6.39796C1.70455 5.59524 2.57045 5.11224 3.62045 4.94898C3.86591 3.72449 4.43182 2.70408 5.31818 1.88776C6.20455 1.07143 7.23409 0.608844 8.40682 0.5V7.62245L7.13864 6.35714C7.01591 6.23469 6.87273 6.17347 6.70909 6.17347C6.54545 6.17347 6.40227 6.23469 6.27955 6.35714C6.15682 6.47959 6.09545 6.62585 6.09545 6.79592C6.09545 6.96599 6.15682 7.11224 6.27955 7.23469L8.59091 9.56122C8.71364 9.68367 8.85682 9.7449 9.02045 9.7449C9.18409 9.7449 9.32727 9.68367 9.45 9.56122L11.7818 7.23469C11.9045 7.11224 11.9659 6.96599 11.9659 6.79592C11.9659 6.62585 11.9045 6.47959 11.7818 6.35714C11.6591 6.23469 11.5125 6.17347 11.342 6.17347C11.1716 6.17347 11.025 6.23469 10.9023 6.35714L9.63409 7.62245V0.5C11.0114 0.64966 12.1636 1.2619 13.0909 2.33673C14.0182 3.41156 14.4818 4.67007 14.4818 6.11224V6.60204C15.4636 6.57483 16.2955 6.89116 16.9773 7.55102C17.6591 8.21088 18 9.04422 18 10.051C18 10.9898 17.6591 11.7993 16.9773 12.4796C16.2955 13.1599 15.4841 13.5 14.5432 13.5H4.31591Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetchIcon);
export default __webpack_public_path__ + "static/media/fetchIcon.d839e50647218f00ed709d5b796c19e7.svg";
export { ForwardRef as ReactComponent };